import { Divider } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import RecordNoImage from "../../../components/recordNotFound/RecordNoImage";
import { useIds } from "../../../hook/AdminContext";
import { s3baseUri } from "../../../config/config";
import { FacebookIcon } from "../../../assets/icon/FacebookIcon";
import InstagramIcon from "../../../assets/icon/InstagramIcon";
import LinkedinIcon from "../../../assets/icon/LinkedinIcon";
import { TwitterIcon } from "../../../assets/icon/TwitterIcon";
import YoutubeIcon from "../../../assets/icon/YoutubeIcon";

import RecordNotFound from "../../../components/recordNotFound/RecordNotFound";
import JobListCard from "../../../components/jobs/JobListCard";
import ManageAffiliates from "./ManageAffiliates";
import ClientAffiliates from "./ClientAffiliates";
import CustomPopoverSection from "../../../components/menu/MebuCustomPopOverSection";
import { useNavigate, useParams } from "react-router-dom";
import ClientsJobAndFeedListing from "./ClientsJobAndFeedListing";
import ClientsJobCard from "./ClientsJobCard";
import Home from "./profile-sections/Home";
import MediaSection from "./profile-sections/MediaSection";
import JobSwiper from "../../../components/CustomSwiper/JobSwiper";
import AchievementListing from "./Media/MediaListing";
import MediaSwiper from "../../../components/CustomSwiper/MediaSwiper";
import {
  address_marker_icon,
  banner_png,
  edit_banner_icon,
  edit_profile_icon,
  facebook_icon,
  instagram_icon,
  linkedin_icon,
  twitter_icon,
  youtube_icon,
} from "../../../assets";
import { Description } from "@mui/icons-material";
import AboutDescription from "./profile-sections/AboutDescription";
import MoreDetails from "./profile-sections/MoreDetails";
import SocialLinks from "./profile-sections/SocialLinks";
import HomePage from "../../home/HomePage";
import JobListing from "./profile-sections/JobListing";
import FixedSizeImageCropper from "../../../components/FixedSizeImageCropper/FixedSizeImageCropper";
import { update_company_cover_photo } from "../../../DAL/features/features";
import { useSnackbar } from "notistack";
import About from "./About";

export default function ClientDetails({
  data,
  isCompanyProfile = false,
  companyType = "",
  isCoachModal = false,
  showSideBar = true,
  fetchDetails = () => {},
}) {
  const navigate = useNavigate();
  const { userInfo, setUpdateJobOnNotification, GetAccessOfCompany } = useIds();
  const { feature_slug } = useParams();

  const { enqueueSnackbar } = useSnackbar();
  const [cardToOpen, setCardToOpen] = useState("home");
  const [jobCardToOpen, setJobCardToOpen] = useState("list");
  const [targetJob, setTargetJob] = useState(null);
  const [jobListing, setJobListing] = useState(data?.jobs || []);
  const [uploadCoverLoading, setUploadCoverLoading] = useState(false);
  const [openCoverCropper, setOpenCoverCropper] = useState(false);
  const [coverImage, setCoverImage] = useState(null);

  const fileInputRef = useRef(null);

  const handleMenuList = () => {
    const Menu_List = [
      {
        title: "Home",
        value: "home",
      },
      {
        title: "About",
        value: "about",
      },
      {
        title: "Posts",
        value: "feed",
      },
      {
        title: "Jobs",
        value: "job",
      },
      {
        title: "Achievements",
        value: "achievements",
      },
      {
        title: "Media",
        value: "media",
      },
      {
        title: "Affiliates",
        value: "affiliates",
      },
    ];

    // if (userInfo.profile_id == data._id) {
    //   Menu_List.push({
    //     title: "Manage Affiliates",
    //     value: "manage-affiliates",
    //   });
    // }
    return Menu_List;
  };

  const handleMoveJobCandidates = (job) => {
    setCardToOpen("job");
    setJobCardToOpen("candidate_list");
    setTargetJob(job);
  };
  const handleMoveJobDetails = (job) => {
    setJobCardToOpen("job_details");
    setCardToOpen("job");
    setTargetJob(job);
  };

  const handleMoveToJobs = () => {
    setCardToOpen("job");
  };
  const handleMoveToPosts = () => {
    setCardToOpen("feed");
  };

  const handleMoveToMedia = (type) => {
    setCardToOpen(type);
  };

  const handleGetMenu = () => {
    let list = [
      {
        label: "Edit Profile",
        icon: "akar-icons:edit",
        handleClick(row) {
          navigate("/profile/edit");
        },
        red_dot: userInfo?.direct_contact_check ? true : false,
      },
    ];

    if (have_edit_access()) {
      list.push({
        label: "Manage Affiliates",
        icon: "tabler:affiliate",
        handleClick(row) {
          navigate("/profile/manage-affiliate");
        },
        red_dot: userInfo?.has_pending_affiliation_request ? true : false,
      });
    }
    return list;
  };

  // useEffect(() => {
  //   const element = document.querySelector(".top-div-client-detail");
  //   if (element) {
  //     setTimeout(() => {
  //       element.scrollIntoView({ behavior: "smooth", block: "start" });
  //     }, 2000);
  //   }
  // }, [jobCardToOpen]);

  const have_edit_access = () => {
    console.log(userInfo.profile_id == data._id, "my profile");

    const status =
      userInfo.profile_id === data._id &&
      ((!userInfo?.isCompanyProfile && userInfo?.role !== "internal_user") ||
        userInfo?.company_access?.manage_profile?.company_profile);

    // const status =
    //   userInfo.profile_id == data._id &&
    //   (userInfo?.isCompanyProfile ||
    //     (userInfo?.isCompanyProfile &&
    //       userInfo?.company_access?.manage_profile?.company_profile));
    return status;
  };

  const handleUpdateSpecificJob = (updatedJob, setList = setJobListing) => {
    if (updatedJob.deleted_job_id) {
      setList((prev) =>
        prev.filter((item) => item._id != updatedJob.deleted_job_id)
      );
      return;
    }
    setList((prev) =>
      prev.map((item) =>
        item._id === updatedJob._id ? { ...item, ...updatedJob } : item
      )
    );
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Original handling for other image types
    const reader = new FileReader();
    reader.onload = () => {
      setCoverImage(reader.result);
      setOpenCoverCropper(true);
    };
    reader.readAsDataURL(file);
  };

  const handleUploadCover = async (file) => {
    setUploadCoverLoading(true);
    const formData = new FormData();
    formData.append("image", file);
    const resp = await update_company_cover_photo(formData);

    if (resp.code == 200) {
      fetchDetails();
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setUploadCoverLoading(false);
  };

  const get_feature_data = () => {
    let publish = false;
    let short_summary = "";
    let profile_type = [];

    if (feature_slug === "hr") {
      publish = data.hr?.publish;
      short_summary = data.hr?.short_summary;
      profile_type = data.hr?.profile_type;
    }
    if (feature_slug === "mindset-source") {
      publish = data.company?.publish;
      short_summary = data.company?.short_summary;
      profile_type = data.company?.profile_type;
    }

    if (feature_slug === "training-source") {
      publish = data.training_provider?.publish;
      short_summary = data.training_provider?.short_summary;
      profile_type = data.training_provider?.profile_type;
    }
    if (!publish) {
      return <></>;
    }
    return (
      <div className=" mt-3">
        <div className="d-flex gap-2 flex-wrap">
          {profile_type.map((type) => (
            <div
              style={{ fontSize: 12, textWrap: "nowrap" }}
              className="input-gray-chip"
            >
              {type.name}
            </div>
          ))}
        </div>
        <div className="mt-3">{short_summary}</div>
      </div>
    );
  };

  useEffect(() => {
    // Register the function
    setUpdateJobOnNotification((data) => {
      handleUpdateSpecificJob(data, setJobListing);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateJobOnNotification(() => {});
    };
  }, [jobListing]);

  console.log(data, "--data");

  return (
    <>
      {/* using this div for scrolling on top ref */}
      <div className="top-div-client-detail"></div>
      {/*  */}
      <div className="row justify-content-center clients-details">
        <div className="col-lg-12">
          {/* main card */}
          <div
            className={`card-1 shadow-md ${
              !isCoachModal ? "pb-0" : ""
            } mb-2 client-basic-info-card`}
          >
            {/* banner card */}
            <div className="position-relative">
              {data?.cover_photo?.thumbnail_1 ? (
                <img
                  className="profile-banner-image"
                  src={s3baseUri + data?.cover_photo?.thumbnail_1}
                  alt=""
                />
              ) : (
                <div
                  className="profile-banner-image"
                  style={{ background: "#ccc" }}
                ></div>
              )}

              {have_edit_access() && (
                <div className="edit-banner-image">
                  {openCoverCropper && (
                    <>
                      <FixedSizeImageCropper
                        image={coverImage}
                        maxSize={{ width: 1584, height: 396 }}
                        onClose={() => setOpenCoverCropper(false)}
                        aspectRatio={4 / 1}
                        handleCropComplete={(file) => {
                          setOpenCoverCropper(false);
                          handleUploadCover(file);
                        }}
                        roundCropAreaPixels={false}
                        open={openCoverCropper}
                      />
                    </>
                  )}
                  {/* Clickable image */}
                  {uploadCoverLoading ? (
                    <div>
                      <div
                        style={{ height: 20, width: 20 }}
                        className="spinner-border text-primary"
                        role="status"
                      ></div>
                    </div>
                  ) : (
                    <img
                      src={edit_banner_icon}
                      alt="Upload banner"
                      onClick={handleImageClick}
                      style={{ cursor: "pointer" }}
                    />
                  )}

                  {/* Hidden file input */}
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept="image/jpeg, image/png, image/webp"
                    style={{ display: "none" }}
                    value={""}
                  />
                </div>
              )}
            </div>

            {/* profile info */}
            <div className="position-relative p-3 pb-0 pt-2">
              <div className="edit-profile-icon-wrapper">
                {have_edit_access() && (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                    className="w-100 text-end"
                  >
                    <CustomPopoverSection
                      custom_icon={edit_profile_icon}
                      custom_icon_height={40}
                      menu={handleGetMenu()}
                      data={data}
                    />

                    {userInfo?.direct_contact_check ||
                    userInfo?.has_pending_affiliation_request ? (
                      <span
                        style={{
                          position: "absolute",
                          top: "-4px",
                          right: "-4px",
                          width: "10px",
                          height: "10px",
                          backgroundColor: "red",
                          borderRadius: "50%",
                          border: "2px solid white",
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
              <div>
                <div className="client-image-wrapper">
                  {data.profile_image?.thumbnail_2 ||
                  data.profile_image?.thumbnail_1 ? (
                    <img
                      src={
                        data.profile_image?.thumbnail_2
                          ? s3baseUri + data.profile_image?.thumbnail_2
                          : s3baseUri + data.profile_image?.thumbnail_1
                      }
                      alt={data.company_name + " Logo"}
                      className="img-fluid"
                    />
                  ) : (
                    <RecordNoImage title={data?.company_name + " Logo"} />
                  )}
                </div>
                <div className={`info-block ${isCoachModal ? "mb-0" : ""}`}>
                  <h6>
                    {isCoachModal
                      ? data.contact_name || data.leader_title || data?.name
                      : data?.company_name}
                  </h6>

                  {data?.tagline && (
                    <div className="ckeditor tinymce-reset about-description">
                      <span>{data.tagline}</span>
                    </div>
                  )}

                  <div className="pt-2 d-flex align-items-center">
                    <div>
                      <img src={address_marker_icon} width={26} alt="" />
                      <span className="!tw-text-sm ps-2 address-value">
                        {data?.location}
                      </span>
                    </div>
                    <div>
                      <MoreDetails
                        data={data}
                        have_edit_access={have_edit_access}
                      />
                    </div>
                  </div>

                  {get_feature_data()}
                </div>
              </div>
            </div>
            <div className="d-block d-md-none px-3 pb-3">
              <SocialLinks data={data} custom_class="justify-content-start" />
            </div>
            {!isCoachModal && (
              <div className="menu-wrapper d-flex justify-content-between">
                <div className="menu-block">
                  {handleMenuList().map((item) => (
                    <span
                      className={`menu-item pb-2 ${
                        cardToOpen == item.value ? "active" : ""
                      }`}
                      onClick={() => {
                        setCardToOpen(item.value);

                        if (item.value == "home") {
                          fetchDetails();
                        }
                        if (item.value == "job") {
                          setJobCardToOpen("list");
                          setTargetJob(null);
                        }
                      }}
                    >
                      {item.title}
                    </span>
                  ))}
                </div>

                {/* SOCIAL LINKS */}
                <SocialLinks data={data} custom_class="d-none d-md-flex" />
                {/*  */}
              </div>
            )}
          </div>
          {cardToOpen == "about" && (
            <div className="w-100">
              <About data={data} />
            </div>
          )}

          <div className="profile-section">
            {cardToOpen == "home" && (
              <div className="d-flex">
                {" "}
                <div className="w-100">
                  <Home
                    data={data}
                    handleMoveToMedia={handleMoveToMedia}
                    fetchDetails={fetchDetails}
                  />
                </div>
                <JobListing
                  data={data}
                  jobListing={jobListing}
                  setJobListing={setJobListing}
                  fetchDetails={fetchDetails}
                  handleMoveJobCandidates={handleMoveJobCandidates}
                  handleMoveJobDetails={handleMoveJobDetails}
                  setCardToOpen={setCardToOpen}
                />
              </div>
            )}

            {(cardToOpen == "job" || cardToOpen == "feed") && (
              <div className="d-flex">
                <ClientsJobAndFeedListing
                  type={cardToOpen}
                  handleBack={() => {
                    setCardToOpen("job");
                    setJobCardToOpen("list");
                  }}
                  clientId={data._id}
                  handleMoveJobCandidates={handleMoveJobCandidates}
                  handleMoveJobDetails={handleMoveJobDetails}
                  jobCardToOpen={jobCardToOpen}
                  targetJob={targetJob}
                  setJobCardToOpen={setJobCardToOpen}
                />
              </div>
            )}
            {cardToOpen == "affiliates" && (
              <ClientAffiliates clientId={data._id} />
            )}
            {cardToOpen === "achievements" && (
              <MediaSection
                mediaType="achievement"
                profile_user_id={data._id}
                have_edit_access={have_edit_access}
              />
            )}

            {cardToOpen === "media" && (
              <MediaSection
                mediaType="media"
                profile_user_id={data._id}
                have_edit_access={have_edit_access}
              />
            )}

            {/* {cardToOpen == "manage-affiliates" && (
            <>
              <ManageAffiliates />
            </>
          )} */}
          </div>
          {cardToOpen == "home" && showSideBar && false && (
            <div>
              <div className="clients-sidebar d-none">
                <div className="shadow-md about-content">
                  {/* job */}
                  <div className="card">
                    <div className="d-flex justify-content-between align-items-center pt-2 px-3">
                      <h6 className="fw-bold mb-0">Company Jobs</h6>
                      <button
                        className="outlined-btn h-auto"
                        onClick={() => {
                          setCardToOpen("job");
                        }}
                      >
                        View All
                      </button>
                    </div>
                    <div className="p-3 pb-0">
                      <JobSwiper
                        slidesPerView={1}
                        data={data.jobs}
                        setJobListing={setJobListing}
                        fetchDetails={fetchDetails}
                        handleMoveJobCandidates={handleMoveJobCandidates}
                        handleMoveJobDetails={handleMoveJobDetails}
                      ></JobSwiper>
                    </div>
                  </div>
                  {/* Achievement */}
                  <div className="card mt-2">
                    <div className="p-3 pb-0">
                      <AchievementListing
                        viewType="slider"
                        mediaType="achievement"
                        media={data.achievements}
                        handleUploadComplete={fetchDetails}
                        handleViewAllClick={handleMoveToMedia}
                        profile_user_id={data._id}
                      />
                    </div>
                  </div>
                  {/* Media */}
                  <div className="card mt-2">
                    <div className="p-3 pb-0">
                      <AchievementListing
                        viewType="slider"
                        mediaType="media"
                        media={data.media}
                        handleUploadComplete={fetchDetails}
                        handleViewAllClick={handleMoveToMedia}
                        profile_user_id={data._id}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/*  */}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
